import { getOrgMemberPermission, RolodexPermissions } from 'features/auth'
const UCAR_ORG_ID = 'ucar-37a0ea'

export const PERMISSIONS_REQUIRING_TERMS: RolodexPermissions[] = [
  getOrgMemberPermission(UCAR_ORG_ID),
]
